import React, { useContext } from 'react'

export interface DrawerStateCtx {
  open: boolean
  toggleDrawer(value: boolean): () => void
}

export const DrawerContext = React.createContext<null | DrawerStateCtx>(null)
export const useDrawerContext = () => {
  const ctx = useContext(DrawerContext)
  if (!ctx) {
    throw new Error('useDrawerContext must be used within <RootLayout/>')
  }

  return ctx
}
